import { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables';
import { RouteKeys } from '~/router/routes.domain';

export const DematRoute: RouteRecordRaw = {
	name: RouteKeys.DEMAT,
	path: 'dematerialization',
	components: {
		default: () => import('../demat/ui/pages/DematAgreementPage.vue')
	},
	meta: {
		label: 'demat.title',
		icon: () => $i('edit-section'),
		requiresAuth: true,
		requireDematAgreementRight: true,
		isSettingsNavEntry: true,
		isSubEntry: false,
		order: 1
	}
};
